<template>

    <Head>
        <meta name="title" content="YDS - YÖKDİL Sınavlarında En Çok Çıkmış 600 Kelime Listesi | Quiz + Telaffuzlar" />
        <title>YDS - YÖKDİL Sınavlarında En Çok Çıkmış 600 Kelime Listesi | Quiz + Telaffuzlar</title>

        <meta name="description"
            content="YDS - YÖKDİL sınavlarında çıkmış en önemli 600 Kelimeyi ve anlamlarını buradan Quiz ile öğrenebilirsiniz. Kelimelerin telaffuzunu dinlemek için ses ikonuna tıklayanız." />

    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">YDS - YÖKDİL Sınavlarında En Çok Çıkmış 600 Kelime Listesi | Quiz + Telaffuzlar</h1>

                <p class="mt-5">Yükseköğretim Kurulu (YÖK) tarafından düzenlenen YDS ve YÖKDİL sınavları, Türkiye'deki
                    üniversite adayları için önemli bir aşamadır. Bu sınavlarda başarılı olmak için kelime bilgisi
                    oldukça kritik bir rol oynamaktadır. Bu yazıda, <b>YDS ve YÖKDİL sınavlarında en çok çıkmış 600
                        kelimenin listesini</b> sizlerle paylaşıyoruz. Bu kelimeleri ezberleyerek sınavda başarı
                    şansınızı
                    artırabilirsiniz.</p>

                <h2 class="archivo mt-4"> YÖKDİL’de kaç kelime sorusu var? Sınav Başarısı için Kelime Bilgisinin Önemi
                </h2>

                <p>Her iki sınavda da, kelime bilgisi, okuma ve anlama becerilerini doğrudan etkileyen bir faktördür. Bu
                    nedenle, sınavlara hazırlık sürecinde kelime dağarcığınızı genişletmek büyük önem taşır. <b>Yökdil
                        sınavında 6 kelime bilgisi ve 14 gramer bilgisi olmak üzere 20 soruluk</b> bir bölüm adayların
                    İngilizce
                    kelime yeterliliğini ölçmektedir.</p>

                <h2 class="archivo mt-4"> YDS sınavı için kaç kelime bilmek gerekir?
                </h2>

                <p>Aşağıda sizler için YDS - YÖKDİL sınavlarında en çok çıkmış <b>600 kelime listesini</b> derledik. Bu
                    listedeki kelimeleri öğrenmeniz sınav başarınızı olumlu yönde etkileyecektir.</p>

                <h2 class="archivo mt-4"> YÖKDİL Hangi seviye?
                </h2>

                <p>Genelde orta seviyenin biraz üstünde <b>(B2) İngilizce yetkinliğine</b> sahip adaylar YÖKDİL
                    sınavlarından başarılı sonuçlar alabilmektedir. </p>

                <h2 class="archivo mt-4"> YDS – YÖKDİL Sağlık Sosyal Fen Kelime Listeleri PDF
                </h2>


                <p> <b>Sağlık, Sosyal ve Fen alanları için soruların içeriği
                        değişebilmekle birlikte aşağıdaki 600 kelimeyi öğrenmek tüm adaylar için önerilir. Kelimeleri
                        çıktı alıp çalışmak istiyorsanız
                        PDF
                        dosyasını aşağıdan indirebilirsiniz. PDF dokümanında her kelimenin anlamı ve örnek cümle içinde
                        kullanımı da bulunmaktadır.</b>
                    PDF dosyasına sadece Premium üyelerimiz erişebilir. Sınırsız PDF indirme avantajının yanında Premium
                    üyelik ile dizilerde kullanılan kelimelere ve özel içeriklere de erişebilirsiniz. Sizler için bu
                    tür özel listeler hazırlamaya devam edeceğiz 😊</p>

                <div class="primary-container">
                    <h3 class="title">YDS - YÖKDİL Kelime Listesi.pdf</h3>
                    <router-link v-if="isPremium" to="/premium/yds-kelime-listesi-pdf">
                        <button class="download-button" data="İNDİR">İNDİR</button>
                    </router-link>
                    <template v-else>
                        <router-link :to="{ path: $store.getters.getLocaleLink('/premium') }"
                            class="text-decoration-none">
                            <button class="upgrade-button" data="Yükselt">PREMİUM</button>
                        </router-link>
                        <small>Sınırsız PDF indirme hakkı ve Premium üyelik sadece 59.99 TL!
                        </small>
                    </template>

                </div>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>
                <h2 class="archivo mt-4"> YDS – YÖKDİL ÇIKMIŞ KELİMELER LİSTESİ</h2>

                <p>Aşağıdaki listede 600 İngilizce kelime türkçe anlamlarıyla birlikte paylaşılmıştır. Ses ikonuna
                    tıklayarak her kelimenin <b>telaffuzunu</b> dinleyebilir, kelimenin üstüne gelerek o kelimenin
                    <b>cümle
                        içindeki örnek bir kullanımını</b> görebilirsiniz. Ayrıca Quiz’e git butonu ile bu kelimeleri
                    <b>7 farklı
                        Quiz modu</b> ile çalışabilirsiniz. Daha önceden bildiğiniz kelimelerin üstüne tıklayarak o
                    kelimeleri
                    listeden çıkarabilirsiniz. Diziyle Öğren’e üye girişi yaparsanız daha önce bildiğiniz kelimeler
                    otomatik olarak listeden çıkarılacaktır. Böylece sadece bilmediğiniz kelimelere odaklanabilirsiniz.
                    Umarız sizler için faydalı olur. Sınavınızda başarılar dileriz 😊
                </p>

                <a target="_blank" rel="nofollow" href="https://x.com/seyfihoca/status/1812551592056627201">KAYNAK:
                    SeyfiHoca</a>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";

export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 20712, MeanLanguageType: 2 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
    computed: {
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        }
    }
}

</script>
<style scoped>
.primary-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    border-radius: 16px;
    background-color: #FBFBFB;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 16px;
    width: 95%;
    max-width: 960px;
}

.title {
    color: var(--Primary, #8887C6);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.upgrade-button {
    width: 144px;
    height: 48px;
    background-color: #B26C6C;
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.download-button {
    width: 144px;
    height: 48px;
    color: var(--Lightest-Gray, #FBFBFB);
    background-color: var(--Green---Success, #9CD189);
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.upgrade-button:hover {
    background-color: #b36060;
}

.download-button:hover {
    background-color: #83c969;
}
</style>